module.exports = __webpack_public_path__ + "/img/Chip-Led-E7eZ6t.svg";